// extracted by mini-css-extract-plugin
module.exports = {"nav":"footer_nav__bXEMq","footer_link":"footer_footer_link__l12kF"};